import React, {Component} from 'react';
import {Container, Form, Nav, Navbar, NavDropdown, NavLink} from "react-bootstrap";
import PropTypes from "prop-types";
import FrequencyVisualizer from "./FrequencyVisualizer";
import {FaCloudDownloadAlt, FaPlay, FaRegStopCircle, FaSync} from "react-icons/fa";

class MainNavBar extends Component {
  static propTypes = {
    analyser: PropTypes.object,
    appTitle: PropTypes.string,
    createADSREnvelope: PropTypes.func,
    createBiquadFilter: PropTypes.func,
    createBufferSource: PropTypes.func,
    createConvolver: PropTypes.func,
    createGain: PropTypes.func,
    createOscillator: PropTypes.func,
    createWaveShaper: PropTypes.func,
    downloadKitConfigJson: PropTypes.func,
    playSynth: PropTypes.func,
    showVisualizer: PropTypes.bool,
    startLoop: PropTypes.func,
    stopLoop: PropTypes.func
  }

  constructor(props) {
    super(props);

    this.state = {};

  }

  render() {
    return (
        <Navbar expand="lg" className="bg-body-tertiary">
          <Container fluid>
            <Navbar.Brand href="#">{this.props.appTitle}</Navbar.Brand>
            <Navbar.Toggle aria-controls="navbarScroll"/>
            <Navbar.Collapse id="navbarScroll">
              <Nav
                  className="me-auto my-2 my-lg-0"
                  style={{maxHeight: '100px'}}
                  navbarScroll>
                <NavLink onClick={this.props.downloadKitConfigJson}><FaCloudDownloadAlt /> Download KitConfig</NavLink>
                <NavLink onClick={this.props.startLoop}><FaSync /> Start Loop</NavLink>
                <NavLink onClick={this.props.stopLoop}><FaRegStopCircle /> Stop Loop</NavLink>
                <NavLink onClick={this.props.playSynth}><FaPlay /> Play</NavLink>
                <NavDropdown title="Add Tool" id="navbarScrollingDropdown">
                  <NavDropdown.Item onClick={this.props.createADSREnvelope}>ADSR Envelope</NavDropdown.Item>
                  <NavDropdown.Item onClick={this.props.createBiquadFilter}>Biquad Filter</NavDropdown.Item>
                  <NavDropdown.Item onClick={this.props.createBufferSource}>Buffer Source</NavDropdown.Item>
                  <NavDropdown.Item onClick={this.props.createConvolver}>Convolver</NavDropdown.Item>
                  <NavDropdown.Item onClick={this.props.createGain}>Gain</NavDropdown.Item>
                  <NavDropdown.Item onClick={this.props.createOscillator}>Oscillator</NavDropdown.Item>
                  <NavDropdown.Item onClick={this.props.createWaveShaper}>WaveShaper</NavDropdown.Item>
                </NavDropdown>
              </Nav>
              <Form className="d-flex">
                <FrequencyVisualizer
                    analyser={this.props.analyser} show={this.props.showVisualizer} /></Form>
            </Navbar.Collapse>
          </Container>
        </Navbar>
    )
        ;
  }
}

export default MainNavBar;
